import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correct in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddPatientReceiptPayments = () => {
    const [payment_receipt, setPaymentReceipt] = useState('');
    const [counter, setCounter] = useState('');
    const [voucher_no, setVoucherNo] = useState('');
    const [date, setDate] = useState('');
    const [customer, setCustomer] = useState('');
    const [against_tender, setAgainstTender] = useState('');
    const [amount, setAmount] = useState('');
    const [debit_ledger, setDebitLedger] = useState('');
    const [cheque_no, setChequeNo] = useState('');
    const [bank_ref, setBankRef] = useState('');
    const [remark, setRemark] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState('');
    const [balance_points, setBalancePoints] = useState('');
    const [last_visit, setLastVisit] = useState('');
    const [email, setEmail] = useState('');
    const [anniversary, setAnniversary] = useState('');
    const [os, setOs] = useState('');

    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const newPaymentReceipt = {
            payment_receipt,
            counter,
            voucher_no,
            date,
            customer,
            against_tender,
            amount,
            debit_ledger,
            cheque_no,
            bank_ref,
            remark,
            name,
            phone,
            dob,
            balance_points,
            last_visit,
            email,
            anniversary,
            os
        };

        fetch(`${BASE_URL}patientreceiptpayments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newPaymentReceipt),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    // Navigate to the payment receipt list or show a success message
                    alert("Payment receipt added successfully!");
                    navigate('/PatientReceiptPaymentsList'); // Assuming the route to list is `/PatientReceiptPaymentsList`
                } else {
                    alert(`Error: ${data.message || 'Please try again.'}`);
                }
            })
            .catch(error => {
                console.error('Error adding payment receipt:', error);
                alert('Error: Unable to connect to the server. Please try again later.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Patient Receipt Payment</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Payment Receipt Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Enter Payment Receipt Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Form Fields */}
                                    <div className="mb-3">
                                        <label htmlFor="payment_receipt" className="form-label">Payment Receipt</label>
                                        <input
                                            type="text"
                                            id="payment_receipt"
                                            className="form-control"
                                            value={payment_receipt}
                                            onChange={(e) => setPaymentReceipt(e.target.value)}
                                            placeholder="Enter payment receipt"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="counter" className="form-label">Counter</label>
                                        <input
                                            type="text"
                                            id="counter"
                                            className="form-control"
                                            value={counter}
                                            onChange={(e) => setCounter(e.target.value)}
                                            placeholder="Enter counter"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="voucher_no" className="form-label">Voucher No.</label>
                                        <input
                                            type="text"
                                            id="voucher_no"
                                            className="form-control"
                                            value={voucher_no}
                                            onChange={(e) => setVoucherNo(e.target.value)}
                                            placeholder="Enter voucher number"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customer" className="form-label">Customer</label>
                                        <input
                                            type="text"
                                            id="customer"
                                            className="form-control"
                                            value={customer}
                                            onChange={(e) => setCustomer(e.target.value)}
                                            placeholder="Enter customer name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="against_tender" className="form-label">Against Tender</label>
                                        <input
                                            type="text"
                                            id="against_tender"
                                            className="form-control"
                                            value={against_tender}
                                            onChange={(e) => setAgainstTender(e.target.value)}
                                            placeholder="Enter tender type"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            placeholder="Enter amount"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="debit_ledger" className="form-label">Debit Ledger</label>
                                        <input
                                            type="text"
                                            id="debit_ledger"
                                            className="form-control"
                                            value={debit_ledger}
                                            onChange={(e) => setDebitLedger(e.target.value)}
                                            placeholder="Enter debit ledger"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="cheque_no" className="form-label">Cheque No.</label>
                                        <input
                                            type="text"
                                            id="cheque_no"
                                            className="form-control"
                                            value={cheque_no}
                                            onChange={(e) => setChequeNo(e.target.value)}
                                            placeholder="Enter cheque number"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bank_ref" className="form-label">Bank Reference</label>
                                        <input
                                            type="text"
                                            id="bank_ref"
                                            className="form-control"
                                            value={bank_ref}
                                            onChange={(e) => setBankRef(e.target.value)}
                                            placeholder="Enter bank reference"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="remark" className="form-label">Remark</label>
                                        <input
                                            type="text"
                                            id="remark"
                                            className="form-control"
                                            value={remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                            placeholder="Enter remark"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            className="form-control"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            placeholder="Enter phone number"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="dob" className="form-label">Date of Birth</label>
                                        <input
                                            type="date"
                                            id="dob"
                                            className="form-control"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="balance_points" className="form-label">Balance Points</label>
                                        <input
                                            type="number"
                                            id="balance_points"
                                            className="form-control"
                                            value={balance_points}
                                            onChange={(e) => setBalancePoints(e.target.value)}
                                            placeholder="Enter balance points"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="last_visit" className="form-label">Last Visit</label>
                                        <input
                                            type="date"
                                            id="last_visit"
                                            className="form-control"
                                            value={last_visit}
                                            onChange={(e) => setLastVisit(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter email"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="anniversary" className="form-label">Anniversary</label>
                                        <input
                                            type="date"
                                            id="anniversary"
                                            className="form-control"
                                            value={anniversary}
                                            onChange={(e) => setAnniversary(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="os" className="form-label">Outstanding Amount</label>
                                        <input
                                            type="number"
                                            id="os"
                                            className="form-control"
                                            value={os}
                                            onChange={(e) => setOs(e.target.value)}
                                            placeholder="Enter outstanding amount"
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Payment Receipt</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Add Payment Receipt Form */}
        </div>
    );
};

export default AddPatientReceiptPayments;
